import { FC, HTMLProps } from 'react';

interface Props extends HTMLProps<SVGSVGElement> {
  unread?: boolean;
}

export const NotificationIcon: FC<Props> = (props) => {
  const { unread, ...other } = props;
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8333 2.49999C10.8333 2.03975 10.4602 1.66666 9.99999 1.66666C9.53975 1.66666 9.16666 2.03975 9.16666 2.49999V3.12499H8.70214C6.84792 3.12499 5.31325 4.56667 5.1975 6.41728L5.01333 9.36182C4.94312 10.4845 4.56621 11.5664 3.92366 12.4896C3.34309 13.3239 3.85994 14.476 4.86905 14.5971L7.70832 14.9378V15.8333C7.70832 17.099 8.73434 18.125 9.99999 18.125C11.2656 18.125 12.2917 17.099 12.2917 15.8333V14.9378L15.1309 14.5971C16.14 14.476 16.6569 13.3239 16.0763 12.4896C15.4338 11.5664 15.0569 10.4845 14.9866 9.36182L14.8025 6.41728C14.6867 4.56667 13.1521 3.12499 11.2978 3.12499H10.8333V2.49999ZM8.70214 4.37499C7.50797 4.37499 6.51961 5.30347 6.44507 6.49531L6.2609 9.43985C6.1764 10.7908 5.72286 12.0927 4.94965 13.2037C4.90769 13.264 4.94504 13.3472 5.01798 13.356L8.1327 13.7298C9.37311 13.8786 10.6269 13.8786 11.8673 13.7298L14.982 13.356C15.0549 13.3472 15.0923 13.264 15.0503 13.2037C14.2771 12.0927 13.8236 10.7908 13.7391 9.43985L13.5549 6.49531C13.4804 5.30347 12.492 4.37499 11.2978 4.37499H8.70214ZM9.99999 16.875C9.42469 16.875 8.95832 16.4086 8.95832 15.8333V15.2083H11.0417V15.8333C11.0417 16.4086 10.5753 16.875 9.99999 16.875Z"
        fill="#4A5154"
      />
      {unread && (
        <path
          d="M14.1666 8.83334C15.8235 8.83334 17.1666 7.4902 17.1666 5.83334C17.1666 4.17649 15.8235 2.83334 14.1666 2.83334C12.5098 2.83334 11.1666 4.17649 11.1666 5.83334C11.1666 7.4902 12.5098 8.83334 14.1666 8.83334Z"
          fill="#E84646"
          stroke="white"
        />
      )}
    </svg>
  );
};
